import { Divider, Empty } from 'antd';

import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { PaginationCursor } from '@component/pagination/pagination-cursor';
import { isExist } from '@util/data/is-exist';

import { useConsumers } from './consumers.hook';
import { consumerColumns } from './consumers.options';
import { SubTitle, SubTitleWrapper, TableConsumer } from './consumers.page-style';
import { NewConsumer } from './new-consumer/new-consumer';

export const ConsumersPage = () => {
  const { data, isLoading, onSelectConsumer, contextHolder, pagination, onNext, onPrevious } = useConsumers();

  return (
    <>
      {contextHolder}
      <PageWrapper>
        <PageTitle>Consumers</PageTitle>
        <Divider />
        <SubTitleWrapper>
          <SubTitle>Consumers</SubTitle>
          <NewConsumer />
        </SubTitleWrapper>
        <TableConsumer
          columns={consumerColumns}
          dataSource={data}
          loading={isLoading}
          locale={{ emptyText: <Empty description='No consumers' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
          pagination={false}
          rowKey='id'
          footer={
            isExist(pagination)
              ? () => <PaginationCursor pagination={pagination} onNext={onNext} onPrevious={onPrevious} />
              : undefined
          }
          onRow={(record) => ({
            onClick: onSelectConsumer(record.id),
          })}
        />
      </PageWrapper>
    </>
  );
};
